

const check = document.querySelector('covet-pics-widget');

if (check) {
  const waitForElement = setInterval(() => {
    const rootElement = document.querySelector('covet-pics-widget');
    if (rootElement.shadowRoot) {
      clearInterval(waitForElement);
      console.log('Root element found:', rootElement);
      
      if (rootElement.shadowRoot) {
        attachStylesToShadowRoot(rootElement);
      } else {
        startObserver(rootElement);
      }
    }
  }, 100);
  
  function startObserver(rootElement) {
    console.log('Starting observer...');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && rootElement.shadowRoot) {
          console.log('Shadow root detected by observer!');
          attachStylesToShadowRoot(rootElement);
          observer.disconnect(); // Stop observing after detecting
        }
      });
    });
  
    observer.observe(rootElement, {
      childList: true,
      subtree: false,
    });
  }
  
  // Start observing
  const rootElement = document.querySelector('covet-pics-widget');
  if (rootElement) {
    startObserver(rootElement);
  }
  
  function attachStylesToShadowRoot(rootElement) {
    const shadowRoot = rootElement.shadowRoot;
    if (shadowRoot) {
      console.log('Shadow root detected!');
      const style = document.createElement('style');
      style.textContent = `
        .btn-load-more {
          background: transparent;
          margin-top: 50px;
          padding: 14px 80px !important;
          font-size: 20px;
          font-weight: 500;
          color: #F15B47;
          border-radius: 8px;
          border: 1px solid #F15B47 !important;
          display: flex;
          width: fit-content;
          margin-inline: auto;
          text-transform: uppercase;
          transition: .3s ease;
          opacity: 1 !important;
        }
        .btn-load-more:hover {
          background-color: #F15B47;
          color: white;
        }
      `;
      shadowRoot.appendChild(style);
    } else {
      console.warn('Shadow root not found');
    }
  }
}



